// import React, { useEffect, useState } from 'react';
import image from '../images/logo.svg';

export const Head = () => {
    // const [sticky, setSticky] = useState(false);
    // useEffect(() => {
    //     const handleScrroll = () => {
    //         if (window.scrollY >= 350) {
    //             setSticky(true)
    //         } else {
    //             setSticky(false)
    //         }
    //     }

    //     document.addEventListener('scroll', handleScrroll)
    // }, [])
    return (
        <header
        // className={`${sticky ? "sticky" : ''}`}
        >
            <nav className="navbar navbar-dark navbar-expand-lg">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={image} alt="logo" />
                        <div className="name">
                            <span>Alikeu</span>
                            <span>Marketing</span>
                        </div>
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarText">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" href="#our-process">Process</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#case-study">Case Studies</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#testimonials">Testimonials</a>
                            </li>
                        </ul>
                        <div className="d-flex">
                            <a className="btn btn-primary" href="#contact">
                                Contact Us
                                <span>&nbsp;<i className="fa-solid fa-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}
